// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__35DQx","title":"style_title__2REo9","blogTitle":"style_blogTitle__2Hv6K"};